import React, { useState, useEffect } from "react";
import FrameworkBanner from "../../frameworkBanner";
import FrameworkStepper from "../../frameworkStepper";
import UploadFile from "../../uploadFile";
import styles from "../../../styles/pages/frameworkPage.module.scss";
import FramworkPdfContainer from "../../frameWorkPdfComponent/index";
import axios from "axios";
import router, { useRouter } from "next/router";
import endPoints from "../../../utility/endpoints";
import UserTypes from "../../../utility/userTypes";
import { BlobServiceClient } from "@azure/storage-blob";
import SuccessModal from "../../../pages/successModal";
import _get from "lodash/get";
import Loader from "../../Loader";
import Icons from "../../../public/assets/svg/index";
import includes from "lodash.includes";
import endpoints from "../../../utility/endpoints";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
function index(props) {
  //console.log("props  drupal----", props);
  const router = useRouter();

  const [restrictedUsers, setRestrictedUser] = useState([
    "endUser",
    "businessUserRegionWise",
    "businessOwner",
    "firstGfcf",
    "gfcf",
    "firstLevelGPMApprover",
    "GPMapprover",
    "gCad",
    "supportStatus"
  ]);
  const [nonRestrictedUser, setNonRestrictedUser] = useState([
    "internalUser",
    "qrManager",
    "releaseManager",
    "editAccess",
    "admin",
  ]);
  //  console.log(props.routes, "routessss")
  const [loader, setLoader] = useState(false);
  const [fileError, setError] = useState(false);
  const [fileTypes, setfileTypes] = useState([
    "pdf",
    "docx",
    "doc",
    "xlsx",
    "msg",
    "jpg",
    "jpeg",
    "png",
    "ppt",
    "pptx",
  ]);
  const {
    component: { content },
  } = props.data[0];
  const stepperImage =
    props.data[1].component.content.field_content_image[0].file_url;

  const stepperImageMobile =
    props.data[1].component.content.field_content_image_mobile[0].file_url;

  const pdfData = _get(props, "data[1].component.content.field_options", []);

  const [successModal, setSuccessModal] = useState(false);
  const [message, setMessage] = useState("Document Added!");
  const [file, setFile] = useState(null);
  const [fileNameOriginal, setFileName] = useState(null);

  const [showFileName, setShowFileName] = useState(false);
  const [automationPdfs, setAutomationPdfs] = useState([]);
  const [confidentialPdfs, setConfidentialPdfs] = useState([]);
  const [auth, setAuth] = useState({});
  const [filenameError, setFileNameError] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem("auth") != undefined) {
        setAuth(JSON.parse(localStorage.getItem("auth")).data);
      }
    } catch (e) {
      console.log("error", e);
    }
  }, []);
  const blobSasUrl =
    "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";

  const blobSasUrlNew = endpoints.blobSasUrlNew;
  // "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

  const containerClient = blobServiceClient.getContainerClient("botstorevideo/FrameworkDocuments");

  const uploadFile = (file, name) => {
    //console.log(file, "pdfsauto");
    //console.log(automationPdfs, "pdfsauto");
    if (
      automationPdfs.filter((item, index) => item.docUrl == file.name).length >
        0 ||
      confidentialPdfs.filter((item, index) => item.docUrl == file.name)
        .length > 0
    ) {
      setFileNameError(true);
      setSuccessModal(true);
      return;
    }

    setFile(file);
    setShowFileName(true);
    setFileName(file.name);
  };

  const uploadButtonClick = async () => {
    //console.log(fileNameOriginal, "fileName", file);

    if (fileNameOriginal == null || docType == null) {
      setError(true);
      return;
    } else {
      setError(false);
    }

    setLoader(true);
    let fileNameWithSpaces = fileNameOriginal;
    let fileName = fileNameWithSpaces.replace(/ /g, "");
    let ar = fileNameOriginal.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file.size;

    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;

      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endPoints.baseUrl}/framework/createFramework`,
          data: {
            docType: extension,
            docName: fileNameOriginal,
            docCategory: docType,
            docUrl: toSend,
            docSize: fileSize,
          },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((resp) => {
          if (resp.data.code == 200) {
            //  console.log(resp);
            window.scrollTo(0, 0);
            setSuccessModal(true);
            setShowFileName(false);
            setLoader(false);
            setFile(null);
            setError(false);
            setFileName(null);
            getAllPdfs();
          } else if (resp.data.code == 403) {
            setLoader(false);
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
        });
      } else {
        setLoader(false)
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log(error, "erro");
      alert("Could not upload");
    }
  };

  const getAllPdfs = async () => {
 
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
     // setLoader(true);
      axios({
        method: "get",
        url: `${endPoints.baseUrl}/framework/getFramework`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((res) => {
        if (res.data.code == 200) {
      //    setLoader(false);
          //console.log(res.data, "framework Response  ---");
          const automationPdfs = res.data.data.filter(
            (item) => item.docCategory == "automation"
          );
          const confidentialPdfs = res.data.data.filter(
            (item) => item.docCategory == "confidential"
          );
          setAutomationPdfs(automationPdfs);
          setConfidentialPdfs(confidentialPdfs);
        } else if (res.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          props.sessionTimeOutCheck(true);
        }
      });
    } else {
      setLoader(false)
      props.sessionTimeOutCheck(true);
    }
  };

  React.useEffect(() => {
    getAllPdfs();
  }, []);

  React.useEffect(() => {
    //console.log(automationPdfs, "automation");
  }, [automationPdfs]);

  const [docType, setDoctype] = React.useState(null);

  const gotDocTypeFromChild = (docTypeState) => {
    if (docTypeState.docType == "Automation factory templates") {
      setDoctype("automation");
    } else {
      setDoctype("confidential");
    }
  };

  return loader ? (
    <div style={{ height: "800px" }}>
      <Loader />
    </div>
  ) : (
    <div className={styles.frameworkContainer}>
      <>
        {/* <button onClick = {() => {router.push(props.routes.Demand)}}>click</button> */}
        <FrameworkBanner data={content} />
        <div className="container">
          <div className="row">
            <div class="col-12 py-5">
              <img
                src={`${endPoints.drupalIp}${stepperImage}`}
                className="d-none d-lg-block hw-100"
              />
              <img
                src={`${endPoints.drupalIp}${stepperImageMobile}`}
                className="d-lg-none d-block m-auto hw-100"
              />
            </div>
          </div>
        </div>
        {/* <FrameworkStepper data = {stepperData}/> */}
        <>
          {auth.userType == "admin" ? (
            <div className={styles.uploadControl}>
              <div className={styles.uploadFileContainer}>
                <UploadFile
                  type="framework"
                  fileType={fileTypes}
                  data={pdfData}
                  uploadFile={uploadFile}
                  uploaded={showFileName}
                  value="frameworkDocument"
                  sendDocTypeToParent={gotDocTypeFromChild}
                />
                {fileError ? (
                  <div style={{ color: "red", fontSize: "10px" }}>
                    Select Some File and doctype
                  </div>
                ) : null}
              </div>

              <div className={styles.actionBtn} onClick={uploadButtonClick}>
                <span>
                  <Icons
                    name="uploadicon"
                    className={styles.uploadIcon}
                  ></Icons>
                  {_get(
                    props,
                    "data[1].component.content.field_upload_file_button_text[0]",
                    ""
                  )}{" "}
                </span>
              </div>
            </div>
          ) : null}
          <div className={styles.pdfViewCardContainer}>
            <FramworkPdfContainer
             auth = {auth}
              data={pdfData[0]}
              download={_get(
                props,
                "data[1].component.content.field_upload_document_component[0].field_document_download_buttons",
                []
              )}
              docsData={automationPdfs}
              setLoader={setLoader}
              getAllPdfs={getAllPdfs}
            />
            {!restrictedUsers.includes(auth.userType) ? (
              <FramworkPdfContainer
              auth = {auth}
                data={pdfData[1]}
                download={_get(
                  props,
                  "data[1].component.content.field_upload_document_component[0].field_document_download_buttons",
                  []
                )}
                docsData={confidentialPdfs}
                setLoader={setLoader}
                getAllPdfs={getAllPdfs}
              />
            ) : null}
          </div>
        </>

        {successModal ? (
          <SuccessModal
            setSuccessModal={() => {
              setSuccessModal(false);
              setFileNameError(false);
            }}
            title={"Framework"}
            message={
              filenameError
                ? "Document with this name already exists."
                : message
            }
            fail={filenameError ? true : false}
          />
        ) : null}
      </>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
